import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "navigator" }
const _hoisted_2 = { class: "nav-left" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "page-info" }
const _hoisted_5 = { class: "nav-right" }

import { ref, computed, watch } from 'vue'
import { EDITOR_MODE } from '../stores/types'
import { qEditorState } from '../stores'
import RevisionComponent from './RevisionComponent.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'NavigatorComponent',
  setup(__props) {

const showHistoryModal = ref(false)

// Closing the history modal without applying a revision must return the editor
// to its live, editable state. setEditorMode(EDITOR) restores body = latestBody
// and clears the previewed revision; without this the editor stays read-only and
// pinned to the old revision with no way back (data-loss trap). "このリビジョンに戻す"
// already switches to EDITOR mode first, so a restore is preserved here.
watch(showHistoryModal, (isOpen) => {
  if (!isOpen && qEditorState.isRevisionMode) {
    qEditorState.setEditorMode({ editorMode: EDITOR_MODE.EDITOR })
  }
})

const questions = computed(() => qEditorState.questions)
const editorMode = computed(() => qEditorState.editorMode)
const currentPage = computed(() => qEditorState.displayCurrentPage)
const isRevisionMode = computed(() => qEditorState.isRevisionMode)

const previous = () => {
  qEditorState.changePage({ page: currentPage.value - 1 })
}

const next = () => {
  qEditorState.changePage({ page: currentPage.value + 1 })
}

const openHistoryModal = () => {
  // Switch to revision mode when opening modal
  if (editorMode.value !== EDITOR_MODE.REVISION) {
    qEditorState.setEditorMode({ editorMode: EDITOR_MODE.REVISION })
  }
  showHistoryModal.value = true
}

const page = computed({
  get: () => currentPage.value,
  set: (value: number) => {
    qEditorState.changePage({ page: value })
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        onClick: previous,
        class: _normalizeClass(["nav-arrow", { disabled: currentPage.value <= 1 }])
      }, [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode("mdi-chevron-left", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ], 2 /* CLASS */),
      _createElementVNode("a", {
        onClick: next,
        class: _normalizeClass(["nav-arrow", { disabled: currentPage.value >= questions.value.length }])
      }, [
        _createVNode(_component_v_icon, null, {
          default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createTextVNode("mdi-chevron-right", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        })
      ], 2 /* CLASS */),
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
        class: "form-control page-select"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questions.value, (question) => {
          return (_openBlock(), _createElementBlock("option", {
            key: question.index,
            value: question.index
          }, _toDisplayString(question.index), 9 /* TEXT, PROPS */, _hoisted_3))
        }), 128 /* KEYED_FRAGMENT */))
      ], 512 /* NEED_PATCH */), [
        [_vModelSelect, page.value]
      ]),
      _createElementVNode("span", _hoisted_4, "/ " + _toDisplayString(questions.value.length) + " 問目", 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        type: "button",
        class: "btn revision-btn btn-outline-success",
        onClick: openHistoryModal
      }, [
        _createVNode(_component_v_icon, {
          size: "18",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("mdi-history", -1 /* CACHED */)
          ]))]),
          _: 1 /* STABLE */
        }),
        _cache[6] || (_cache[6] = _createTextVNode(" ヒストリー ", -1 /* CACHED */))
      ])
    ]),
    _createCommentVNode(" History Modal "),
    _createVNode(_component_v_dialog, {
      modelValue: showHistoryModal.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showHistoryModal).value = $event)),
      "max-width": "600",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "history-modal" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "history-modal-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, { class: "mr-2" }, {
                  default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                    _createTextVNode("mdi-history", -1 /* CACHED */)
                  ]))]),
                  _: 1 /* STABLE */
                }),
                _cache[9] || (_cache[9] = _createTextVNode(" ヒストリー ", -1 /* CACHED */)),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  icon: "",
                  variant: "text",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (showHistoryModal.value = false))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode("mdi-close", -1 /* CACHED */)
                      ]))]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "history-modal-content" }, {
              default: _withCtx(() => [
                _createVNode(RevisionComponent)
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})